// extracted by mini-css-extract-plugin
export default {"wrapper":"contactIcon_wrapper__WmRWE","icon":"contactIcon_icon__ScXr5","title":"contactIcon_title__GNlM9","description":"contactIcon_description__a0lTX"};